module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-right.2f29a2cb.svg";